import React from 'react';

export default function About() {
    return (
        <div className="container-fluid">
            <h2>Events Client Web</h2>
            <div className="row">
                <div className="col-sm-12">
                Sample Brahma Kumaris Events navigator
                </div>
            </div>
        </div>
    )
}